import React from 'react';
import storeManager from '../../../store/StoreManager';
import Draggable from 'react-draggable';
import { uiProperties } from '../../utils/TransformToolUtils';
import zoomUtils from '../../utils/ZoomUtils';
import configuration from '../../../constants/Configuration';
import platformDetection from '../../utils/PlatformDetection';
import { refreshShapePosition } from '../../../actions/MenuActions';

export const CroppingTransformTool = React.createClass({
    getInitialState() {
        const hotspot = this.getCurrentHotspot();
        zoomUtils.currentCroppingHotspot = hotspot;
        zoomUtils.updateCurrentCroppingHotspot = this.updateCurrentHotspotFromInputValue;
        zoomUtils.updateTransformTool = this.updateTransformTool;

        return {
            x: hotspot.x,
            y: hotspot.y,
            width: hotspot.width,
            height: hotspot.height,
            startX: -1,
            startY: -1,
            startWidth: -1,
            startHeight: -1
        };
    },
    refreshInitialPosition() {
        setTimeout(this.updateCroppingInitialPosition, 1);
    },
    updateCroppingInitialPosition() {
        const hotspot = this.getCurrentHotspot();

        this.setState({
            x: hotspot.x,
            y: hotspot.y,
            width: hotspot.width,
            height: hotspot.height
        });

        zoomUtils.updateCroppingInitialPosition = false;

        setTimeout(this.updateHotspot, 5);
    },
    onScaleStart(e) {
        e.preventDefault();

        this.setState({
            startX: this.state.x,
            startY: this.state.y,
            startWidth: this.state.width,
            startHeight: this.state.height
        });

        zoomUtils.updateCroppingInitialPosition = false;
    },
    onScaleDrag(e, coreEvent) {
        e.preventDefault();

        let id = coreEvent.node.id;
        var x = this.state.startX;
        var y = this.state.startY;
        var width = this.state.startWidth;
        var height = this.state.startHeight;

        switch (id) {
            case 'topLeft':
            {
                x = this.state.startX + coreEvent.lastX / this.scaleFactor();
                y = this.state.startY + coreEvent.lastY / this.scaleFactor();
                width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
                height = this.state.startHeight - coreEvent.lastY / this.scaleFactor();

                break;
            }

            case 'topRight':
            {
                y = this.state.startY + coreEvent.lastY / this.scaleFactor();
                width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
                height = this.state.startHeight - coreEvent.lastY / this.scaleFactor();

                break;
            }

            case 'bottomLeft':
            {
                x = this.state.startX + coreEvent.lastX / this.scaleFactor();
                width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
                height = this.state.startHeight + coreEvent.lastY / this.scaleFactor();

                break;
            }

            case 'bottomRight':
            {
                width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
                height = this.state.startHeight + coreEvent.lastY / this.scaleFactor();

                break;
            }
        }

        const minSize = 30;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);

        if (x < realShape.x)
            x = realShape.x;

        if (y < realShape.y)
            y = realShape.y;

        if (x + width > realShape.x + realShape.width)
            width = realShape.x + realShape.width - x;

        if (y + height > realShape.y + realShape.height)
            height = realShape.y + realShape.height - y;

        if (width >= minSize && height >= minSize) {
            this.setState({
                x,
                y,
                width,
                height
            });
        }
    },
    onScaleStopped() {
        this.updateHotspot();
        storeManager.getStore().dispatch(refreshShapePosition());
    },
    getRealShapeSize(shapeModel) {
        var newShape;

        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
            var realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
            var realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
            var x1 = realWidth * shapeModel.hotSpot.x1 / 100;
            var y1 = realHeight * shapeModel.hotSpot.y1 / 100;
            newShape = {};

            newShape.width = realWidth;
            newShape.height = realHeight;
            newShape.x = shapeModel.x - x1;
            newShape.y = shapeModel.y - y1;
        } else
            newShape = shapeModel;

        return newShape;
    },
    updateHotspot() {
        var hotspotX1 = this.state.x;
        var hotspotY1 = this.state.y;
        var hotspotX2 = hotspotX1 + this.state.width;
        var hotspotY2 = hotspotY1 + this.state.height;
        var newShape = this.getRealShapeSize(zoomUtils.croppingTarget);

        var shapeX1 = newShape.x;
        var shapeY1 = newShape.y;
        var shapeX2 = shapeX1 + newShape.width;
        var shapeY2 = shapeY1 + newShape.height;
        var realHotspot;

        if (shapeX1 >= hotspotX2 || shapeX2 <= hotspotX1 || shapeY1 >= hotspotY2 || shapeY2 <= hotspotY1) {
            // no hotspot
        } else {
            realHotspot = {};

            if (hotspotX1 <= shapeX1)
                realHotspot.x1 = 0;
            else
                realHotspot.x1 = (hotspotX1 - shapeX1) * 100 / newShape.width;

            if (hotspotX2 >= shapeX2)
                realHotspot.x2 = 100;
            else
                realHotspot.x2 = (hotspotX2 - shapeX1) * 100 / newShape.width;

            if (hotspotY1 <= shapeY1)
                realHotspot.y1 = 0;
            else
                realHotspot.y1 = (hotspotY1 - shapeY1) * 100 / newShape.height;

            if (hotspotY2 >= shapeY2)
                realHotspot.y2 = 100;
            else
                realHotspot.y2 = (hotspotY2 - shapeY1) * 100 / newShape.height;
        }

        zoomUtils.currentCroppingHotspot = realHotspot;
    },
    getCurrentHotspot() {
        var hotspotModel = {};
        var shapeModel = zoomUtils.croppingTarget;

        if (shapeModel) {
            hotspotModel.x = shapeModel.x;
            hotspotModel.width = shapeModel.width;
            hotspotModel.y = shapeModel.y;
            hotspotModel.height = shapeModel.height;
        } else {
            hotspotModel.width = 400;
            hotspotModel.height = 400 * 9 / 16;
            hotspotModel.x = 200;
            hotspotModel.y = 450 / 2 - hotspotModel.height / 2;
        }

        return hotspotModel;
    },
    updateCurrentHotspotFromInputValue(property, value) {
        const minSize = 30;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);
        var localHotSpot = {x1: zoomUtils.currentCroppingHotspot.x1, x2: zoomUtils.currentCroppingHotspot.x2, y1: zoomUtils.currentCroppingHotspot.y1, y2: zoomUtils.currentCroppingHotspot.y2};
        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);

        switch (property) {
            case 'x1': {
                localHotSpot.x1 = value;

                if (localHotSpot.x1 + xMinLimitPercents > localHotSpot.x2)
                    localHotSpot.x1 = localHotSpot.x2 - xMinLimitPercents;
                break;
            }
            case 'x2': {
                if (value > 100)
                    value = 100;

                localHotSpot.x2 = value;
                break;
            }
            case 'y1': {
                localHotSpot.y1 = value;

                if (localHotSpot.y1 + yMinLimitPercents > localHotSpot.y2)
                    localHotSpot.y1 = localHotSpot.y2 - yMinLimitPercents;
                break;
            }
            case 'y2': {
                if (value > 100)
                    value = 100;

                localHotSpot.y2 = value;
                break;
            }
        }

        zoomUtils.currentCroppingHotspot = localHotSpot;

        this.updateTransformTool();

        storeManager.getStore().dispatch(refreshShapePosition());
    },
    updateTransformTool() {
        const minSize = 30;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);
        var localHotSpot = {x1: zoomUtils.currentCroppingHotspot.x1, x2: zoomUtils.currentCroppingHotspot.x2, y1: zoomUtils.currentCroppingHotspot.y1, y2: zoomUtils.currentCroppingHotspot.y2};

        var x = realShape.x + (realShape.width * localHotSpot.x1) / 100;
        var y = realShape.y + (realShape.height * localHotSpot.y1) / 100;
        var width = realShape.width * (localHotSpot.x2 - localHotSpot.x1) / 100;
        var height = realShape.height * (localHotSpot.y2 - localHotSpot.y1) / 100;

        if (x < realShape.x)
            x = realShape.x;

        if (y < realShape.y)
            y = realShape.y;

        if (x + width > realShape.x + realShape.width)
            width = realShape.x + realShape.width - x;

        if (y + height > realShape.y + realShape.height)
            height = realShape.y + realShape.height - y;

        if (width >= minSize && height >= minSize) {
            this.setState({
                x,
                y,
                width,
                height
            });
        }
    },
    onMoveStart(e) {
        e.preventDefault();

        this.setState({
            startX: this.state.x,
            startY: this.state.y
        });

        zoomUtils.updateCroppingInitialPosition = false;
    },
    onMoveDrag(e, coreEvent) {
        e.preventDefault();

        var x = this.state.startX + coreEvent.lastX / this.scaleFactor();
        var y = this.state.startY + coreEvent.lastY / this.scaleFactor();
        var width = this.state.width;
        var height = this.state.height;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);

        if (x < realShape.x)
            x = realShape.x;

        if (y < realShape.y)
            y = realShape.y;

        if (x + width > realShape.x + realShape.width)
            x = realShape.x + realShape.width - width;

        if (y + height > realShape.y + realShape.height)
            y = realShape.y + realShape.height - height;

        this.setState({
            x,
            y
        });
    },
    onMoveStopped() {
        this.updateHotspot();
    },
    scaleFactor() {
        const canvasScale = this.props.scaleProperties.scale;
        return canvasScale;
    },
    isVisible() {
        const state = storeManager.getState();
        const showCroppingMenu = state.menu.showCroppingMenu;

        if (showCroppingMenu == undefined || showCroppingMenu == false)
            return false;
        else
            return true;
    },
    render() {
        if (this.isVisible() == false)
            return (<g></g>);

        if (zoomUtils.updateCroppingInitialPosition == true)
            this.refreshInitialPosition();

        const x = this.state.x;
        const y = this.state.y;
        const width = this.state.width;
        const height = this.state.height;
        const scale = this.props.scaleProperties.scale;

        let pathPoints = `M0 0 L${width} 0 L${width} ${height} L0 ${height} Z`;

        let cornerFill = uiProperties.CORNER_FILL_INACTIVE;
        let cornerStroke = uiProperties.CORNER_STROKE_INACTIVE;

        const canvasWidth = configuration.CANVAS_WIDTH;
        const canvasHeight = configuration.CANVAS_HEIGHT;

        var radiusOffset = 0;

        if (platformDetection.isIOS())
            radiusOffset = 2;

        const radius = (uiProperties.RADIUS + radiusOffset) / scale;
        var extraRadius = radius;

        return (
            <g transform={`translate(${x} ${y})`}>
                <rect x={-x} y={-y} width={x} height={canvasHeight} fill='#000000' fillOpacity={0.5}/>
                <rect x={width} y={-y} width={canvasWidth - x - width} height={canvasHeight} fill='#000000' fillOpacity={0.5}/>
                <rect x={0} y={- y} width={width} height={y} fill='#000000' fillOpacity={0.5}/>
                <rect x={0} y={height} width={width} height={canvasHeight - y - height} fill='#000000' fillOpacity={0.5}/>

                <path stroke={uiProperties.PATH_COLOR} strokeWidth={uiProperties.STROKE} fill="none" d={pathPoints}/>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMoveStart} onDrag={this.onMoveDrag} onStop={this.onMoveStopped}>
                    <rect x={0} y={0} width={this.state.width} height={this.state.height} fill='#000000' fillOpacity={0}/>
                </Draggable>

                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="topLeft" cx={0 - extraRadius/1.5} cy={0 - extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="topRight" cx={width + extraRadius/1.5} cy={0 - extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="bottomRight" cx={width + extraRadius/1.5} cy={height + extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="bottomLeft" cx={0 - extraRadius/1.5} cy={height + extraRadius/1.5} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
            </g>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/interactive/CroppingTransformTool.js
 **/